import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
	Reservation,
	ReservationRefundRecipient,
	ReservationRefundRecipientPayload,
	ReservationSms,
	Result,
} from './reservation.model';

@Injectable()
export class ReservationApiService {
	private readonly API_URL = environment.apiUrl;
	private readonly httpClient = inject(HttpClient);

	updateReservation(reservationId: number, payload: Partial<Reservation>): Observable<Reservation> {
		return this.httpClient.patch<Reservation>(`${this.API_URL}/reservation/${reservationId}/`, payload);
	}

	getReservationSms(reservationId: number): Observable<ReservationSms[]> {
		return this.httpClient
			.get<Result<ReservationSms>>(`${this.API_URL}/reservation/${reservationId}/sms/`)
			.pipe(map((result) => result?.results));
	}

	getRefundRecipient(reservationId: number): Observable<ReservationRefundRecipient | null> {
		return this.httpClient.get<ReservationRefundRecipient | null>(
			`${this.API_URL}/reservation/${reservationId}/refund_recipient/`,
		);
	}

	createRefundRecipient(
		reservationId: number,
		payload: ReservationRefundRecipientPayload,
	): Observable<ReservationRefundRecipient> {
		return this.httpClient.post<ReservationRefundRecipient>(
			`${this.API_URL}/reservation/${reservationId}/refund_recipient/`,
			payload,
		);
	}

	updateRefundRecipient(
		reservationId: number,
		payload: ReservationRefundRecipientPayload,
	): Observable<ReservationRefundRecipient> {
		return this.httpClient.patch<ReservationRefundRecipient>(
			`${this.API_URL}/reservation/${reservationId}/refund_recipient/`,
			payload,
		);
	}
}
